import { render } from "./approvalMailServices.vue?vue&type=template&id=4a919d70&scoped=true&ts=true"
import script from "./approvalMailServices.vue?vue&type=script&lang=ts"
export * from "./approvalMailServices.vue?vue&type=script&lang=ts"

import "./approvalMailServices.vue?vue&type=style&index=0&id=4a919d70&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a919d70"]])

export default __exports__